<template lang='pug' src='./meet-us.pug'></template>

<script>
import Hero from 'components/hero/hero'
import Loader from 'components/loader/loader'
import MeetDr from 'components/custom/custom-meet-dr/custom-meet-dr'
import TabSection from 'components/block/block-tab-section/block-tab-section'
import Testimonial from 'components/block/block-testimonial/block-testimonial'

export default {
  name: 'meet-us',
  created () {
    if (!this.$route.hash) {
      this.$store.dispatch('VIEW_NAV', 0)
    }
  },
  computed: {
    props () {
      return this.$store.state.pages['about-us']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Hero,
    Loader,
    MeetDr,
    Testimonial,
    TabSection
  }
}
</script>



// WEBPACK FOOTER //
// meet-us.vue?6dc32a7e